import type { ClaimPolymorph } from '../types/claim-types';
import { isIncidentConfiguration } from '../types/claim-types';
import type { IncidentConfigurationBase } from '../types/incident-configuration-types';

export const isFutureDateOfLossAllowed = (config?: IncidentConfigurationBase | null): boolean =>
  !!config?.incident_details?.pre_defined_fields?.date_of_loss?.allow_future;

export const extractPreDefinedFieldsFromClaim = (claim?: ClaimPolymorph) =>
  isIncidentConfiguration(claim?.incident_configuration)
    ? {
        ...claim.incident_configuration?.incident_details?.pre_defined_fields,
        ...claim.incident_configuration?.fnol,
        primary_contact_id: claim.incident_configuration?.incident_details?.pre_defined_fields?.preferred_contact_id,
      }
    : {};
